/**
 * Offline status indicator — shown in the app sidebar/header.
 * Displays connection status + pending sync queue count.
 */

import { useOfflineSync } from '@/hooks/useOfflineSync';
import { Wifi, WifiOff, Loader2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export default function OfflineIndicator() {
  const { online, pendingCount, syncing } = useOfflineSync();

  // Don't show anything if online and queue is empty
  if (online && pendingCount === 0) return null;

  return (
    <div
      className="flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium transition-colors"
      style={{
        background: online ? 'rgba(34,197,94,0.1)' : 'rgba(239,68,68,0.1)',
        color: online ? '#22c55e' : '#ef4444',
      }}
    >
      {!online ? (
        <>
          <WifiOff className="h-3.5 w-3.5" />
          <span>Hors ligne</span>
        </>
      ) : syncing ? (
        <>
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
          <span>Sync...</span>
        </>
      ) : (
        <>
          <Wifi className="h-3.5 w-3.5" />
          <span>En ligne</span>
        </>
      )}
      {pendingCount > 0 && (
        <Badge variant="destructive" className="h-4 min-w-4 px-1 text-[10px]">
          {pendingCount}
        </Badge>
      )}
    </div>
  );
}
